/**
 * Storage keys for auth/session.
 * Web app uses WEB_AUTH_STORAGE_KEY; extension popup uses 'user' (see helpers/storage.ts).
 * Do not use the same key for both unless you intentionally share session between web and extension.
 */
export const WEB_AUTH_STORAGE_KEY = 'flower_power_notes_user';
